<template>
  <div class="designs-container">
    <CRow class="mb-4">
      <CCol class="col-12">
        <b-button v-b-modal.fileModal class="float-right mb-3" variant="primary">Add Factory Cuttings</b-button>
      </CCol>
    </CRow>
    <CRow>
      <CCol class="col-8"></CCol>
      <CCol class="col-4">
        <b-form-input v-model="search_term" class="mr-sm-2" placeholder="Type to Search Cutting Files by name" @keyup.enter="searchCuttingFiles"></b-form-input>
      </CCol>
    </CRow>
    <template v-if="cutting_files.length > 0">
      <CRow v-for="(cutting_file, cfIdx) in cutting_files" :key="cfIdx">
        <CCol class="col-sm-12">
          <CRow class="container_row">
            <CCol class="col-8">{{ cutting_file.file_name }}</CCol>
            <CCol class="col-4">
              <plus class="actions mr-2"  fillColor="#009FE3" @click="cutting_file.show_child_rows = !cutting_file.show_child_rows"/>
              <edit class="actions mr-2"  fillColor="#009FE3" @click="editCuttingFile(cfIdx, cutting_file.id)"/>
              <!--            <delete class="actions mr-2" fillColor="#C80000" />-->
            </CCol>
          </CRow>
          <template v-if="cutting_file.show_child_rows">
            <CRow class="files_row" v-for="(file_size, fsIdx) in cutting_file.file_sizes" :key="fsIdx">
              <CCol class="col-8">
                <CRow>
                  <CCol class="col-6">{{file_size}}</CCol>
                  <CCol class="col-6">
                    <a :href="`${storage_url}/factory_cuttings/${cutting_file.id}/${file_size}.svg`" target="_blank">
                      <inline-svg
                          :src="`${storage_url}/factory_cuttings/${cutting_file.id}/${file_size}.svg`"
                          width="150"
                          height="150"
                          fill="black"
                          aria-label="My image"
                          stroke-width="5px"
                      ></inline-svg>
                    </a>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </template>
        </CCol>
      </CRow>
    </template>
    <template v-else>
      <CRow>
        <CCol class="col-sm-12">
          <CRow class="container_row">
            <CCol class="col-sm-12">
              No data found

            </CCol>
          </CRow>
        </CCol>
      </CRow>
    </template>
    <div style="margin-bottom: 10px"></div>

    <b-pagination
        v-model="pagination_data.currentPage"
        :total-rows="pagination_data.rows"
        :per-page="pagination_data.perPage"
        aria-controls="itemList"
        align="center"
        @change="goToPage"
        v-if="pagination_data.total > 0"
    ></b-pagination>
    <b-modal no-close-on-backdrop hide-footer id="fileModal" :title="'Upload Cutting Sizes File'" @close="modelClosedEventHandler">
      <CRow>
        <CCol class="col-12">
          <label class="required">Select Design File</label>
          <b-form-file accept=".svg" name="file" v-validate="'required|ext:svg'" v-model="cutting_file_obj.file"></b-form-file>
          <div v-if="errors && errors.first('file')" class="error_msg">
            {{ errors.first('file')}}
          </div>
          <b-button @click="handleCuttingAllSizesFile" class="mt-2 float-right" variant="primary">Upload</b-button>
        </CCol>
      </CRow>
    </b-modal>
  </div>
</template>

<script>

import Plus from "vue-material-design-icons/Plus.vue";
import Edit from 'vue-material-design-icons/Pencil.vue';
import $ from "jquery";
import {startsWith, forEach, filter, replace, uniq, join} from "lodash"
import {http} from "@/config/httpCommon";
import InlineSvg from 'vue-inline-svg';


export default {
  name: "Listing",
  components: {
    Plus,
    Edit,
    InlineSvg
  },
  data() {
    return {
      search_term: "",
      cutting_size_file_template: null,
      cutting_files: [],
      storage_url: process.env.VUE_APP_FILE_URL,
      validate_dict: {
        custom: {
          file: {
            ext: () => 'The uploaded file must have SVG extension'
          }
        }
      },
      pagination_data:{
        rows:null,
        currentPage:null,
        perPage:null,
        total:0
      },
      cutting_file_obj: {
        id: null,
        index: null,
        file: null
      }
    }
  },
  mounted() {
    let self = this;
    self.$validator.localize('en', this.validate_dict);
    self.getFactoryCuttings();
  },
  methods: {
    getFactoryCuttings(params = null) {
      let self = this;
      let url = "cutting-files";
      if(params) {
        url += params;
      }
      http.get(url).then(successResponse => {
        let response_data = successResponse.data;
        let result = response_data.result;
        self.cutting_files = result.cutting_files.data
        self.setPaginationData(result.cutting_files);
      }).catch((error) => {
            console.log('Error getting factory cuttings', error)
          })
    },
    setPaginationData(data){
      this.pagination_data.currentPage = data.current_page;
      this.pagination_data.rows = data.total;
      this.pagination_data.perPage = data.per_page;
      this.pagination_data.total = data.total;
    },
    goToPage(go_to_page) {
      let self = this;
      let params = `?page=${go_to_page}`
      if(self.search_term) {
        params += `&search_term=${self.search_term}`
      }
      self.getFactoryCuttings(params);
    },
    searchCuttingFiles() {
      let self = this;
      let params = null;
      if(self.search_term) {
        params  = `?search_term=${self.search_term}`
      }
      self.getFactoryCuttings(params);
    },
    async handleCuttingAllSizesFile() {
      let self = this;
      let valid = await self.$validator.validate();
      if(valid) {
        let reader = new FileReader();
        reader.readAsText(self.cutting_file_obj.file);
        reader.onload = async function() {
          let svg_items = $(reader.result);
          await self.createCuttingSizeFileTemplate(svg_items);
          await self.getCuttingSizesFromSizesFile(svg_items);
          console.log("after getCuttingSizesFromSizesFile")
        }
      }
    },
    async createCuttingSizeFileTemplate(svg_items) {
      let size_file_template = "";
      forEach(svg_items, (svg_item) => {
        let node_name = svg_item.nodeName;
        let node_value = svg_item.nodeValue
        let svg_attributes = []
        switch (node_name) {
          case "#comment":
            size_file_template += startsWith(node_value, "?xml") ? `<${node_value}>` : `<!--  ${node_value} -->`
            break;
          case "#text":
            size_file_template += node_value
            break;
          case "svg":
            svg_attributes = svg_item.attributes
            size_file_template += `<${node_name}`
            forEach(svg_attributes, (svg_attribute) => {
              size_file_template += ` ${svg_attribute.nodeName}="${svg_attribute.nodeValue}"`
            })
            size_file_template += ">\n";
            size_file_template += "{{svg_content}}";
            size_file_template += `\n</${node_name}>`
            break;
          default:
            console.warn(`switch case (${node_name}) not handled while creating cutting size file template`)
        }
      })
      this.cutting_size_file_template = size_file_template;
      return size_file_template;
    },
    getCuttingSizesFromSizesFile(svg_items) {
      let self = this;
      let svg_elements =  filter(svg_items, ["nodeName", "svg"]);
      if(svg_elements.length > 0) {
        let svg_element = svg_elements[0];
        let cutting_sizes = filter(svg_element.childNodes, ["nodeName", "g"]);
        if(cutting_sizes.length > 0) {
          self.uploadCuttingSizes(cutting_sizes)
        } else {
          console.warn("Sizes file have no cutting size")
        }
      } else {
        console.warn("No svg element found")
      }
    },
    async uploadCuttingSizes(cutting_sizes) {
      let self = this;
      self.$store.commit('set', ['showLoader', true]);
      let cutting_all_sizes = await self.getAllSizes(cutting_sizes);
      let size_file_template = this.cutting_size_file_template;
      let cutting_file_id = null;
      let for_loop_count = 1;
      let total_cutting_size_files = cutting_sizes.length
      let uploaded_cutting_files = 0;
      for(const cutting_size of cutting_sizes) {
        let group_id = $(cutting_size).attr("id");
        if (startsWith(group_id, "_x3")) {
          group_id = replace(group_id, "_x3", "");
        }
        let size_name = group_id.substr(0, group_id.search("_"))
        let cutting_size_file_content = replace(size_file_template, "{{svg_content}}", cutting_size.innerHTML);
        let file_name = `${size_name}.svg`;
        let action = self.cutting_file_obj.id ? 'update' : 'create';
        let formData = new FormData();
        formData.append('cutting_size_file', new File([new Blob([cutting_size_file_content])], file_name));
        if (for_loop_count == 1) {
          formData.append('file_sizes', cutting_all_sizes);
          formData.append('all_sizes_file_name', self.cutting_file_obj.file.name);
          formData.append('action', action);
          if(action == "update") {
            formData.append('cutting_file_id', self.cutting_file_obj.id);
          }
          let first_file_response = await http.post('cutting-files/upload/size-file', formData);
          let response_data = first_file_response.data;
          let result = response_data.result
          cutting_file_id = result.cutting_file_id
          let updated_file_sizes = result.file_sizes
          ++uploaded_cutting_files;
          if(action == "update") {
            self.cutting_files[self.cutting_file_obj.index].file_sizes = updated_file_sizes;
            self.cutting_files[self.cutting_file_obj.index].file_name = self.cutting_file_obj.file.name;
          }
          if(total_cutting_size_files == uploaded_cutting_files) {
            self.allSizesUploaded();
          }
        } else {
          formData.append('cutting_file_id', cutting_file_id);
          http.post('cutting-files/upload/size-file', formData).then(() => {
            ++uploaded_cutting_files;
            if(total_cutting_size_files == uploaded_cutting_files) {
              self.allSizesUploaded();
            }
          }).catch((error) => {
            console.log('Error uploading cutting size file', error)
          })
        }
        ++for_loop_count;
      }
    },
    allSizesUploaded() {
      let self = this;
      self.$bvModal.hide('fileModal');
      self.$store.commit('set', ['showLoader', false]);
      if(!self.cutting_file_obj.id) {
        self.getFactoryCuttings();
      }
    },
    async getAllSizes(cutting_size_groups, get_array=false) {
      let file_sizes = [];
      forEach(cutting_size_groups, (cutting_size_group) => {
        let group_id = $(cutting_size_group).attr("id");
        if(startsWith(group_id, "_x3" )) {
          group_id = replace(group_id, "_x3", "");
        }
        let cutting_size = group_id.substr(0, group_id.search("_"));
        file_sizes.push(cutting_size);
      })
      file_sizes = uniq(file_sizes);
      return get_array ? file_sizes :  join(file_sizes, ",");
    },

    editCuttingFile(cutting_file_index, cutting_file_id) {
      let self = this;
      self.cutting_file_obj.id = cutting_file_id;
      self.cutting_file_obj.index = cutting_file_index;
      self.$bvModal.show('fileModal');
    },
    modelClosedEventHandler() {
      let self = this;
      self.cutting_file_obj = { id: null, index: null, file: null }
    }
  }
}
</script>

<style scoped>
.container_row{
  background-color: #dedede;
  padding: 10px 0;
  border-bottom: 1px solid #dede;
}
.files_row{
  padding: 10px 0;
  border-bottom: 1px solid #dddddd;
}
.actions{
  cursor: pointer;
}
</style>